var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash-symbol-wrapper"},[(_vm.elementIsEnabled('jagfx_elements_mid_top_parkingBrake'))?_c('div',{staticClass:"dash-symbol",class:{
        red: _vm.$parent.telemetry2.symbols.parkingBrakeIsEnabled,
        left: _vm.sideLeft(),
        right: _vm.sideRight()
      }},[_vm._m(0)]):_vm._e(),(_vm.elementIsEnabled('jagfx_elements_mid_top_retarder'))?_c('div',{staticClass:"dash-symbol",class:{
        green: _vm.$parent.telemetry2.symbols.retarderIsActive,
        left: _vm.sideLeft(),
        right: _vm.sideRight()
      }},[_vm._m(1)]):_vm._e(),(_vm.elementIsEnabled('jagfx_elements_mid_top_beacon'))?_c('div',{staticClass:"dash-symbol",class:{
        green: _vm.$parent.telemetry2.symbols.beaconIsEnabled,
        left: _vm.sideLeft(),
        right: _vm.sideRight()
      }},[_vm._m(2)]):_vm._e(),(_vm.elementIsEnabled('jagfx_elements_mid_top_beamHigh'))?_c('div',{staticClass:"dash-symbol",class:{
        blue: _vm.$parent.telemetry2.symbols.mainBeamIsEnabled,
        left: _vm.sideLeft(),
        right: _vm.sideRight()
      }},[_vm._m(3)]):_vm._e(),(_vm.elementIsEnabled('jagfx_elements_mid_top_beamLow'))?_c('div',{staticClass:"dash-symbol",class:{
        green: _vm.$parent.telemetry2.symbols.lowBeamIsEnabled,
        left: _vm.sideLeft(),
        right: _vm.sideRight()
      }},[_vm._m(4)]):_vm._e(),_vm._l((_vm.indexEmptyElement()),function(i){return _c('div',{key:i,staticClass:"dash-symbol disabled",class:{ left: _vm.sideLeft(), right: _vm.sideRight() }})})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"icon-parking_brakes"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"icon-retarder"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"icon-beacons"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"icon-beam_high"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"icon-beam_low"})])
}]

export { render, staticRenderFns }